// Vista para aprobar o rechazar solicitudes 

//Imports 
import React from 'react';
import {Col, Row, Input, Typography, Button, Avatar, Card, Descriptions, Divider, Breadcrumb, Tag, Modal, Spin} from "antd";
import axios from 'axios';
import {getPaises, getRegiones, getCiudades, getOrganismos, getSponsors, updateVisitaPersona,getEstadosCiviles,getMunicipios} from "./VisitConsumer";
import {CloseCircleTwoTone} from '@ant-design/icons';
import {notification} from "antd/lib/index";

const {confirm} = Modal;
const {Title} = Typography;
const {TextArea} = Input;

//Componente Vista Formulario por un Funcionario 
class VistaFormularioFuncionario extends React.Component {
    constructor(props) {
        super(props);
        //Estado del componente 
        this.state = {
            data: null,
            estado: "Sin información",
            rutParse: "",
            pais: "",
            ciudad: "",
            region: "",
            nacionalidad: "",
            estado_civil: "",
            patrocinador: "",
            reparticion: "",
            organismo: "",
            departamento: "",
            visitaSinCargar: true,
            modalGetDataError: false,
            disabledButtons: false
        }
        this.comentario = React.createRef();
    };

    componentDidMount() {
        //Todos los parametros que necesitados desde la API los cargamos y guardamos en el estado 
        const visitID = this.props.match.params.visitID;
        axios.get(window.ENV.API_URL + '/visita/'.concat(`${visitID}`) + '/', {
            headers: {
                Authorization: window.Token
            }
        }).then((res) => {
            
            let flag_0 = 0;
            let rut_data = res.data?.ID_FORMULARIO.RUT_PASAPORTE;
            let rutPasaporte = '';
            
            if(rut_data[0] != 'P'){
                for (let i = 0; i < rut_data.length; i++) {
                    if(rut_data[i] != 0){
                        flag_0 = 1;
                    }

                    if(flag_0 == 1){
                        if(i < rut_data.length-1){
                            rutPasaporte = rutPasaporte + rut_data[i]
                        }else{
                            rutPasaporte = rutPasaporte + '-' + rut_data[i]
                        }
                    }
                }
            }else{
                rutPasaporte = rut_data;
            }
            this.setState({rutParse : rutPasaporte});

            const id_ciudad = res.data.ID_FORMULARIO.ID_CIUDAD;
            const id_unidad = res.data.ID_SOLICITUD.ID_ORGANISMO;
            const id_patrocinador = res.data.ID_SOLICITUD.ID_PATROCINADOR;
            const id_estado_civil = res.data.ID_FORMULARIO.ID_ESTADO_CIVIL;
            const id_pais = res.data.ID_FORMULARIO.ID_PAIS;
            const id_nacionalidad = res.data.ID_FORMULARIO.ID_NACIONALIDAD;

            getPaises().then((info) => {
                const pais = info.data.filter(val => val.id_pais === id_pais)[0];
                const nacionalidad = info.data.filter(val => val.id_pais === id_nacionalidad)[0];
                this.setState({pais: pais?.nombre, nacionalidad: nacionalidad?.nacionalidad})
            });
            if(res.data.ID_FORMULARIO.ID_REGION != 0){
                getMunicipios().then((info) => {
                    const municipio = info.data.municipio.filter(val => val.id_municipio === id_ciudad)[0];
                    if(municipio){
                        this.setState({ciudad: municipio.nombre})
                        getRegiones().then((info2) => {
                            const region = info2.data.filter(val => val.id_region === municipio.id_region)[0];
                            if(region){
                                this.setState({region: region.nombre})
                            }
                        });
                    }
                });
            }else{
                getCiudades().then((info) => {
                    const ciudad = info.data.filter(val => val.id_ciudad === id_ciudad)[0];
                    if(ciudad){
                        this.setState({ciudad: ciudad.nombre})
                        getRegiones().then((info2) => {
                            const region = info2.data.filter(val => val.id_region === ciudad.id_region)[0];
                            if(region){
                                this.setState({region: region.nombre})
                            }
                        });
                    }
                });
            }
            getEstadosCiviles().then((response) => {
                const estado_civil = response.data.filter(val => val.id_estado_civil === id_estado_civil)
                this.setState({estado_civil: estado_civil[0].nombre})
            });
            getOrganismos().then((info) => {
                const departamento = info.data.filter(val => val.id_organismo === id_unidad)[0];
                const organismo = info.data.filter(val => val.id_organismo === departamento.id_organismo_padre)[0];
                const reparticion = info.data.filter(val => val.id_organismo === organismo.id_organismo_padre)[0];
                this.setState({reparticion: reparticion?.nombre, organismo: organismo?.nombre, departamento: departamento?.nombre})
            });
            getSponsors([res.data.ID_SOLICITUD.ID_PATROCINADOR]).then((info) => {
                const patrocinador = info.data.filter(val => parseInt(val.id_persona) === id_patrocinador)[0];
                this.setState({patrocinador: patrocinador?.nombres + ' ' + patrocinador?.paterno + ' ' + patrocinador?.materno})
            });

            let estadoVal = ""

            if(res.data.ID_ESTADO_SOLICITUD == 2){
                estadoVal = 'Rechazado y pendiente a cambios';
            }else if(res.data.ID_ESTADO_SOLICITUD == 5){
                estadoVal = 'Rechazado';
            }else{
                estadoVal = res.data.ESTADO;
            }
            this.setState({visitaSinCargar : false, data: res.data, estado: estadoVal});
        }).catch((error) => {
            // alert("There is an error in API call.");
            this.setState({visitaSinCargar : false});
            this.setState({modalGetDataError: true});
            return
        });
    }

    handleChangeSolicitud = (estado) => {
        this.setState({disabledButtons : true});
        var comentario = this.comentario.current.state.value;
        if (comentario || estado == 1) {
            if(estado == 1){
                comentario = "Aprobado"
            }

            const values = {
                id_visita: this.state.data.ID_VISITA,
                rut_pasaporte: this.state.data.ID_FORMULARIO.RUT_PASAPORTE,
                comentario: comentario,
                estado: estado
            }

            const {history} = this.props;
            updateVisitaPersona(values).then(function (response) {
                var mensaje_popup = "Aprobación exitosa"
                
                if(estado == 2 || estado == 5){
                    mensaje_popup = "Rechazo exitoso"
                }
                
                history.push('/myrequests', notification.open({
                    message: mensaje_popup,
                    description: "Se ha modificado la visita correctamente.",
                    type: "success",
                    duration: 5,
                }))
            }).catch(function (error) {
                console.log(error);
                this.setState({disabledButtons : false});
                notification.open({
                    message: "Error",
                    description: "Ocurrió un problema.",
                    type: "error",
                    duration: 5,
                });
            });
        }else{
            this.setState({disabledButtons : false});
            notification.open({
                message: "Comentario faltante",
                description: "Debe indicar el motivo del rechazo.",
                type: "warning",
                duration: 5,
            })
        }
    }


    render() {
        return (
            <div>
                <div>
                    <Modal visible={this.state.modalGetDataError} width={600} style={{textAlign: 'center', color: '#d1bd00'}} closeIcon=' ' footer={null}>
                        <CloseCircleTwoTone style={{fontSize: "49px"}}twoToneColor="#FF4D4F"/>
                            <div style={{color:"#47525E", fontSize: "20px", marginTop: "10px"}}>Ocurrio un error obteniendo la información</div>
                        <Divider style={{background: '#969FAA'}}/>
                        <div style={{textAlign: 'right'}}>
                            <Button className='global-principal-button' onClick={event => window.location.href='/myrequests'} >ACEPTAR</Button>
                        </div>
                    </Modal>
                </div>
                <Spin spinning={this.state.visitaSinCargar} tip="Cargando Datos…">
                <Breadcrumb>
                    <Breadcrumb.Item>
                        <a href="/main">Menú principal</a>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item><a href="/myrequests">Mis solicitudes</a></Breadcrumb.Item>
                    <Breadcrumb.Item>Solicitud</Breadcrumb.Item>
                </Breadcrumb>
                <Card>
                    <Row>
                        <Col span={24}>
                            <div style={{fontSize:"25px", color:"#1978B8"}}>
                                <b>Solicitud</b> <Tag style={{
                                borderColor: "#f95f62",
                                backgroundColor: "#f95f62",
                                color: "#ffffff"
                            }}
                            >
                                {this.state.estado}</Tag>
                            </div>
                        </Col>
                    </Row>
                    <Row style={{marginBottom: 26}}>
                        <Col span={24}>
                            <b className='viewform-title'>
                                Datos Personales
                            </b>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Avatar src={this.state.data?.ID_FORMULARIO.picture_by_rca} shape="square" /* size={200} */  style={{width: "57.5%", height:"77%"}} />
                        </Col>
                        <Col span={18}>
                            <Descriptions column={2}>
                                <Descriptions.Item label={<label className='viewform-item'>Nombre</label>}><div className='viewform-data'>{this.state.data ? 
                                this.state.data?.ID_FORMULARIO.NOMBRES + " " + this.state.data?.ID_FORMULARIO.PATERNO + " " + this.state.data?.ID_FORMULARIO.MATERNO : 
                                "Sin información"}</div></Descriptions.Item>
                                <Descriptions.Item label={<label className='viewform-item'>RUT/Pasaporte</label>}><div className='viewform-data'>{this.state.data ? this.state.rutParse : "Sin información"}</div></Descriptions.Item>
                                <Descriptions.Item label={<label className='viewform-item'>Email</label>}><div className='viewform-data'>{this.state.data ? this.state.data?.ID_FORMULARIO.EMAIL : "Sin información"}</div></Descriptions.Item>
                                <Descriptions.Item label={<label className='viewform-item'>Teléfono</label>}><div className='viewform-data'>{this.state.data ? this.state.data?.ID_FORMULARIO.TELEFONO : "Sin información"}</div></Descriptions.Item>
                                <Descriptions.Item label={<label className='viewform-item'>País</label>}><div className='viewform-data'>{this.state.pais ? this.state.pais : "Sin información"}</div></Descriptions.Item>
                                <Descriptions.Item label={<label className='viewform-item'>Región</label>}><div className='viewform-data'>{this.state.region ? this.state.region : "Sin información"}</div></Descriptions.Item>
                                <Descriptions.Item label={<label className='viewform-item'>Ciudad</label>}><div className='viewform-data'>{this.state.ciudad ? this.state.ciudad : "Sin información"}</div></Descriptions.Item>
                                <Descriptions.Item label={<label className='viewform-item'>Dirección</label>}><div className='viewform-data'>{this.state.data ? this.state.data?.ID_FORMULARIO.DIRECCION : "Sin información"}</div></Descriptions.Item>
                                <Descriptions.Item label={<label className='viewform-item'>Fecha de nacimiento</label>}><div className='viewform-data'>{this.state.data ? this.state.data?.ID_FORMULARIO.FECHA_NACIMIENTO.substring(8,10) + '-' + this.state.data?.ID_FORMULARIO.FECHA_NACIMIENTO.substring(5,7) + '-' + this.state.data?.ID_FORMULARIO.FECHA_NACIMIENTO.substring(0,4) : "Sin información"}</div></Descriptions.Item>
                                <Descriptions.Item label={<label className='viewform-item'>Género</label>}><div className='viewform-data'>{this.state.data ? this.state.data?.ID_FORMULARIO.GENERO : "Sin información"}</div></Descriptions.Item>
                                <Descriptions.Item label={<label className='viewform-item'>Estado civil</label>}><div className='viewform-data'>{this.state.estado_civil ? this.state.estado_civil : "Sin información"}</div></Descriptions.Item>
                                <Descriptions.Item label={<label className='viewform-item'>Nacionalidad</label>}><div className='viewform-data'>{this.state.nacionalidad ? this.state.nacionalidad : "Sin información"}</div></Descriptions.Item>
                            </Descriptions>
                        </Col>
                    </Row>
                    <Divider/>

                    <Row style={{marginBottom: 26}}>
                        <Col span={24}>
                            <b className='viewform-title'>
                                Datos relacionados con la visita
                            </b>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={18}>
                            <Descriptions column={2}>
                                <Descriptions.Item label={<label className='viewform-item'>Repartición</label>}><div className='viewform-data'>{this.state.reparticion ? this.state.reparticion : "Sin información"}</div></Descriptions.Item>
                                <Descriptions.Item label={<label className='viewform-item'>Tipo de visita</label>}><div className='viewform-data'>{this.state.data ? this.state.data?.ID_SOLICITUD.TIPO_VISITA : "Sin información"}</div></Descriptions.Item>
                                <Descriptions.Item label={<label className='viewform-item'>Organismo</label>}><div className='viewform-data'>{this.state.organismo ? this.state.organismo : "Sin información"}</div></Descriptions.Item>
                                <Descriptions.Item label={<label className='viewform-item'>Patrocinador</label>}><div className='viewform-data'>{this.state.patrocinador ? this.state.patrocinador : "Sin información"}</div></Descriptions.Item>
                                <Descriptions.Item label={<label className='viewform-item'>Departamento</label>}><div className='viewform-data'>{this.state.departamento ? this.state.departamento : "Sin información"}</div></Descriptions.Item>
                                <Descriptions.Item label={<label className='viewform-item'>Vigencia</label>}><div className='viewform-data'>{ this.state.data ? 
                                this.state.data?.ID_SOLICITUD.FECHA_INICIO.substring(8,10) + '-' + this.state.data?.ID_SOLICITUD.FECHA_INICIO.substring(5,7) + '-' + this.state.data?.ID_SOLICITUD.FECHA_INICIO.substring(0,4) + " a " + this.state.data?.ID_SOLICITUD.FECHA_TERMINO.substring(8,10) + '-' + this.state.data?.ID_SOLICITUD.FECHA_TERMINO.substring(5,7) + '-' + this.state.data?.ID_SOLICITUD.FECHA_TERMINO.substring(0,4) : 
                                "Sin información"}</div></Descriptions.Item>
                            </Descriptions>
                        </Col>
                    </Row>
                    <Divider/>

                    <Row style={{marginBottom: 26}}>
                        <Col span={24}>
                            <b className='viewform-title'>
                                Resolución
                            </b>
                        </Col>
                    </Row>
                    <Row>
                        <Descriptions>
                            {this.state.data?.ID_ESTADO_SOLICITUD == 5 || this.state.data?.ID_ESTADO_SOLICITUD == 2 ?
                                <Descriptions.Item label="Observación del rechazo">
                                    {this.state.data?.COMENTARIO}
                                </Descriptions.Item> : ""}
                        </Descriptions>
                        <Col span={15}>
                            <Row>
                                <TextArea rows={4} className='viewform-observacion' placeholder="Observaciones ..." ref={this.comentario}/>
                            </Row>
                            <Row>
                                {this.state.data?.ID_ESTADO_SOLICITUD != 1 ?
                                    this.state.disabledButtons ?
                                        <Button disabled style={{margin: 10}} className='global-principal-button' onClick={() => {this.handleChangeSolicitud(1)}}>APROBAR</Button> :
                                        <Button style={{margin: 10}} className='global-principal-button' onClick={() => {this.handleChangeSolicitud(1)}}>APROBAR</Button> : "" }
                                {this.state.data?.ID_ESTADO_SOLICITUD != 5 ?
                                    this.state.disabledButtons ?
                                        <Button disabled style={{margin: 10}} className='global-secundario-button' onClick={() => {this.handleChangeSolicitud(5)}}>RECHAZAR</Button> : 
                                        <Button style={{margin: 10}} className='global-secundario-button' onClick={() => {this.handleChangeSolicitud(5)}}>RECHAZAR</Button> : ""}
                                {this.state.data?.ID_ESTADO_SOLICITUD != 2 ?
                                    this.state.disabledButtons ?
                                        <Button disabled style={{margin: 10}} className='global-secundario-button' onClick={() => {this.handleChangeSolicitud(2)}}>RECHAZAR Y REENVIAR FORMULARIO</Button> : 
                                        <Button style={{margin: 10}} className='global-secundario-button' onClick={() => {this.handleChangeSolicitud(2)}}>RECHAZAR Y REENVIAR FORMULARIO</Button> : ""}
                            </Row>
                        </Col>
                    </Row>
                </Card>
                </Spin>
            </div>
        );
    }
}

export default VistaFormularioFuncionario;